import { UnitSystem, UnitSystemConfig } from '../types/unit-system';

export type { UnitSystemConfig };

const IMPERIAL_CONFIG: UnitSystemConfig = {
  system: 'imperial',
  temperature: { symbol: '°F', name: 'Fahrenheit' },
  speed: { symbol: 'mph', name: 'miles per hour' },
  distance: { symbol: 'mi', name: 'miles' },
};

const METRIC_CONFIG: UnitSystemConfig = {
  system: 'metric',
  temperature: { symbol: '°C', name: 'Celsius' },
  speed: { symbol: 'km/h', name: 'kilometers per hour' },
  distance: { symbol: 'km', name: 'kilometers' },
};

export const LOCALE_UNIT_CONFIG: Record<string, UnitSystemConfig> = {
  'en-US': IMPERIAL_CONFIG,
  'en-GB': METRIC_CONFIG,
  'de-DE': METRIC_CONFIG,
  'de-CH': METRIC_CONFIG,
  'es-MX': METRIC_CONFIG,
  'fr-FR': METRIC_CONFIG,
};

export const DEFAULT_UNIT_CONFIG: UnitSystemConfig = IMPERIAL_CONFIG;

export function getLocaleUnitConfig(languageCode: string): UnitSystemConfig {
  if (!languageCode) {
    return DEFAULT_UNIT_CONFIG;
  }

  if (LOCALE_UNIT_CONFIG[languageCode]) {
    return LOCALE_UNIT_CONFIG[languageCode];
  }

  const baseLanguage = languageCode.split('-')[0];
  const matchingKey = Object.keys(LOCALE_UNIT_CONFIG).find((key) => key.startsWith(`${baseLanguage}-`));
  return matchingKey ? LOCALE_UNIT_CONFIG[matchingKey] : DEFAULT_UNIT_CONFIG;
}

export function getUnitConfigForSystem(system: UnitSystem): UnitSystemConfig {
  return system === 'metric' ? METRIC_CONFIG : IMPERIAL_CONFIG;
}

